import { GlobalAreaV2 } from '@libs/templates/global-area-v2';
import { BusinessShellV2 } from './BusinessShellV2';

/**
 * 新UI（v2）の枠で組む画面のコンテナ。
 *
 * 既存FA画面が通る {@link ContainerWithContext} とは別に立てる。既存画面は ppfw-client の
 * `Template`（枠線・影・`calcViewAreaHeight()` による高さの実測）を各画面で描いているため、
 * 共通のコンテナに v2 の枠を入れると枠と高さ計算が二重になる。route 単位で適用先を選べる形に
 * しておき、v2 に移した画面だけをこちらに移す。
 *
 * provider 群は親の {@link FaContainer} が持つ。エージェントの chat widget は現段階では
 * 載せない（新UIでの置き場所が未決）。
 */
function ContainerV2() {
  return (
    <>
      <GlobalAreaV2 subsystemName="FA" homePath="/fa/main-menu" shouldHideNotification />
      <BusinessShellV2 />
    </>
  );
}

export { ContainerV2 };
